//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from '~/eventBus'

export default {
    name: 'LayoutDefault',

    data(){ return {
        showFooter: false,
    }},

    mounted(){

    },

    methods: {

    }

}
